import { render, staticRenderFns } from "./ButtonAddField.vue?vue&type=template&id=103d9c60&scoped=true&v-slot%3Aextension=true&"
import script from "./ButtonAddField.vue?vue&type=script&lang=js&"
export * from "./ButtonAddField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103d9c60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
